// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__H6exV","rootSuccess":"CompleteLink_rootSuccess__30pw_","rootFailure":"CompleteLink_rootFailure__3sEa5","isDisabled":"CompleteLink_isDisabled__2NmrA"};